export const DOCUMENT_IDS = {
  PURCHASE_ORDER: "purchaseOrder",
  INVOICE: "salesInvoice",
  PROFORMA_INVOICE: "proformaSalesInvoice",
  CREDIT_NOTE: "salesCrMemo",
  PROFORMA_CREDIT_NOTE: "proformaSalesCrMemo",
  SAMPLE_SWATCH_LABELS: "sampleSwatchLabels",
  CNC_TASK_LABELS: "cncTaskLabels",
  PRODUCT_ID_LABELS: "productIdLabels",
  STOCK_ITEM_BARCODES: "stockItemBarcodes",
};

export const INVOICE_DOCUMENT_IDS = [
  DOCUMENT_IDS.INVOICE,
  DOCUMENT_IDS.PROFORMA_INVOICE,
  DOCUMENT_IDS.CREDIT_NOTE,
  DOCUMENT_IDS.PROFORMA_CREDIT_NOTE,
];

export const USER_INPUT_LABEL_DOCUMENT_IDS = [
  DOCUMENT_IDS.SAMPLE_SWATCH_LABELS,
  DOCUMENT_IDS.CNC_TASK_LABELS,
  DOCUMENT_IDS.PRODUCT_ID_LABELS,
];

export const PRODUCT_ID_LABEL_PAGE_WIDTH_MM = 51;
export const PRODUCT_ID_LABEL_PAGE_HEIGHT_MM = 25.5;

export const REACT_TEMPLATES = [
  DOCUMENT_IDS.PURCHASE_ORDER,
  DOCUMENT_IDS.SAMPLE_SWATCH_LABELS,
  DOCUMENT_IDS.CNC_TASK_LABELS,
  DOCUMENT_IDS.PRODUCT_ID_LABELS,
  DOCUMENT_IDS.STOCK_ITEM_BARCODES,
];
